import { render, staticRenderFns } from "./MypagePointMonthlySection.vue?vue&type=template&id=31c4e2c0&scoped=true"
import script from "./MypagePointMonthlySection.vue?vue&type=script&lang=ts"
export * from "./MypagePointMonthlySection.vue?vue&type=script&lang=ts"
import style0 from "./MypagePointMonthlySection.vue?vue&type=style&index=0&id=31c4e2c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c4e2c0",
  null
  
)

export default component.exports